var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_coreJsData.js
// module id = 1659
// module chunks = 3 9 13